import React from "react";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Wrapper } from "../../shared/Wrapper";
import { Choices } from "../../shared/Choices";
import styles from "./styles.module.scss";

/**
 * @param {{
 *  question: string;
 *  description?: string;
 *  value: number;
 *  required?: boolean;
 *  onChange: (value: number) => void;
 *  allowComment?: boolean;
 *  comment?: string;
 *  onCommentChange?: (comment: string) => void;
 * }} param0
 */
export function QuestionScale({
  question,
  description,
  value,
  required,
  onChange,
  allowComment,
  comment,
  onCommentChange,
}) {
  var { tSurvey: t } = useAppTranslation.Survey();
  var OPTIONS = [1, 2, 3, 4, 5].map((x) => ({ id: x, text: x.toString() }));

  return (
    <Wrapper
      title={question}
      description={description}
      required={required}
      allowComment={allowComment}
      comment={comment}
      onCommentChange={onCommentChange}
    >
      <Choices
        options={OPTIONS}
        values={value ? [value] : []}
        onChange={(options) => onChange(options?.[0])}
      />
      <div className={styles.scaleDesc}>
        <span>{t("scale_min")}</span>
        <span>{t("scale_max")}</span>
      </div>
    </Wrapper>
  );
}
